import React, { useEffect, useState } from "react";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { bm_date, drawPOSStatus, drawPrice, istl } from "../utils/Utils";
import Space from "../ui/Space";
import Card from "../ui/Card";
import Label from "../ui/Label";
import Divider from "../ui/Divider";
import { CheckIcon, PinIcon } from "../utils/Icons";

export default function ProcessingList(props) {

    const {
        controller = "",
        signal = {},
        loading = false,
        setLoading = () => { },
        data = [],
        setData = () => { },
        selected = 0,
        setSelected = () => { },
        route = "",
        align = "start",
        setAlign = () => { },
        view = true,
        filters = {},
        setFilters = () => { },
        row_key = "purchase_order_id",
    } = props;




    const buffer = 20;
    const columns = [

        { min: true, width: 60, key: "supplier_code", align: "left", title: <>Supl</>, render: (e, f) => {
            return <div style={f.status !== "Pend" ? { color: "var(--text-light)" } : f.total_items >= f?.supplier?.minimum_quantity && drawPrice(f?.total_net_price, true) >= f?.supplier?.minimum_retail ? { color: "var(--text-green)" } : {}}>{f?.supplier?.code || ""}</div>
        }},
        { min: true, width: 52, key: "separator", align: "left", title: <>Group</> },
        { min: true, width: 80, key: "status", align: "left", title: <>Stat</>, render : (e, f) => {
            return <>{e} {(f?.ready) ? <CheckIcon /> : ""}</>
        } },
        { min: true, width: 80, key: "order_number", align: "left", title: <>Order</> },
        { min: true, width: 100, key: "status_date", align: "left", title: <>Date / Age</>, render :(e) => {
            return (e) ? <span style={{"fontFamily" : "var(--font-mono)"}}>{bm_date(e)}</span> : ""
        } },
        { min: true, width: 80, key: "send_via", align: "left", title: <>SndVia</> },
        { min: true, width: 50, key: "total_special_orders", align: "left", title: <>S/O</> },
        { min: true, width: 100, key: "total_items", align: "left", title: <>#Bks</> },
        { min: true, width: 100, key: "total_sell_price", align: "left", title: <>SellTtl</>, render: (e, f) => {
            return (< >{drawPrice(f.total_sell_price, true)}</>)
        } },
        { min: true, width: 100, key: "supplier_type", align: "left", grow: true, title: <>Type</> },

    ];


    //     {
    //     "cancel_date": null,
    //     "cancel_days": 0,
    //     "id": "019a5035-8f43-7747-9060-6e8aee600b79",
    //     "order_number": "",
    //     "ready": false,
    //     "send_via": "Rep",
    //     "sent_date": 0,
    //     "separator": " ",
    //     "ship_via": "",
    //     "status": "Pend",
    //     "status_date": 1744182000000,
    //     "supplier": {
    //         "acct": "",
    //         "alt_bill": 0,
    //         "alt_ship": 0,
    //         "backorder": "Y",
    //         "cancel_days": 60,
    //         "code": "!",
    //         "consignment": null,
    //         "currency": "CA",
    //         "discount": "",
    //         "edi_format": " ",
    //         "exchange_rate": 1,
    //         "last_active_date": "",
    //         "markup": 1,
    //         "minimum_quantity": 0,
    //         "minimum_retail": 0,
    //         "minimum_type": " ",
    //         "name": "Suggested Orders",
    //         "note": "",
    //         "note_keynum": "0034422",
    //         "order_via": "R",
    //         "payment_supplier": "",
    //         "po_sort": "T",
    //         "san": "",
    //         "ship_via": "",
    //         "short_discount_margin": 25,
    //         "tax_group_code": "XMPT",
    //         "use_isbn": "I",
    //         "vendor_type": " ",
    //         "website": ""
    //     },
    //     "supplier_code": "!",
    //     "supplier_type": "!",
    //     "total_items": 7,
    //     "total_list_price": 6941,
    //     "total_net_price": 4165,
    //     "total_sell_price": 16593,
    //     "total_special_orders": 0
    // }

    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");

        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        // Fetch chunk...

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;

        if (prevIndex < 1) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };

    const fetchNext = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("purchase_order.getNext", { ...filters, "purchase_order_id": data[data.length - 1]?.[row_key] }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const fetchPrev = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("purchase_order.getPrevious", { ...filters, "purchase_order_id": data[0]?.[row_key] }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r.concat([...data])]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    const fetch = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("purchase_order.getInitial", { ...filters }, (_s, _r) => {
            if (_s) {

                if (_r.rows_previous.length > 0) {
                    setAlign("start");
                }
                setData(_r.rows_previous.concat(_r.rows_next));

                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})

            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(fetch, []);



    return (
        <div style={{ "display": (view) ? "block" : "none", "padding": "0px" }}>
            <Label style={{ "textAlign": "left" }}>&nbsp;Purchase Orders</Label>
            <div className="shim" />
            <Space grow size={10} style={{ "alignItems": "start" }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 740, width: 900 }}>

                    <VirtualTable
                        rounded
                        controller={controller}
                        scrollbar={true}
                        scrollindicator={true}
                        infinite={true}
                        onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                        next={next}
                        prev={prev}
                        onLoadMore={(_start, _end, _prepend) => {
                            if (_prepend) {
                                if (data?.length > 0 && data[0]?.number !== 1) {
                                    fetchPrev()
                                }
                            } else {
                                if (data?.length > 0) {
                                    fetchNext();
                                }

                            }
                        }}
                        align={align}
                        row_key={row_key}
                        current={selected}
                        data={data}
                        height={460}
                        columns={columns}
                        width={0}
                        loading={loading}
                        offset={480}
                        route={route}
                    />
                </div>

            </Space>

        </div >
    )
}